export default __webpack_public_path__ + "static/media/casesTwo3.51fd5dda.webp";